/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge,ShimmerButton,ShimmerTitle,ShimmerThumbnail, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'

export default function ProductDetailShimmer() {
    return (
        <div className="md:px-[46px] px-4">
            <p className="text-xs3 font-normal text-[#808285] pt-2.5">
                Consumables  Hardfacing Electrode  High Temperature Oxidation - Impact - Abrasion  Nimoten-Plus 535 B</p>
            <div className="flex -mx-3 sm:pt-3 pt-0 flex-wrap">
                <div className="xl:w-[37.5%] lg:w-1/2 w-full lg:pt-0 pt-5 px-3">
                    <div>
                        <ShimmerThumbnail height={370} rounded   className="w-full mb-0" />
                        <div className="mt-1">
                            <div id="carouselExampleControls" className="carousel slide relative" data-bs-ride="carousel" data-bs-interval="false">
                                <div className="carousel-inner relative w-full overflow-hidden">
                                    {[...Array(4)].map((prod,i)=>(
                                        <div className="carousel-item active relative float-left w-full " key={`${i+11}`}>
                                            <div className="flex">
                                                {[...Array(6)].map((img)=>(
                                                    <ShimmerThumbnail key={img} height={70} rounded   className="w-full block mr-2"/>

                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xl:w-[37.5%] lg:w-1/2 w-full lg:pt-0 pt-5 px-3">
                    <div className="flex items-center">
                        <ShimmerTitle line={1} gap={10} variant="primary"/>
                    </div>
                    <p className="sm:text-sm text-xs2 font-normal text-[#808285] mt-1"><span><ShimmerBadge width={120} className="sm:px-4 px-2"/></span><span className="sm:px-4 px-2"></span><ShimmerBadge width={120} className="sm:px-4 px-2"/></p>
                    <div className="pt-[18px]">
                        <p className="text-xs17 font-normal text-[#555259]">
                            <ShimmerText line={9} gap={10} variant="primary" />

                        </p>
                    </div>
                    <div className="sm:pt-[36px] pt-5 flex sm:flex-row flex-col">
                        <div className="bg-[#EAEAF0] rounded-md sm:pt-2.5 pt-2 sm:pl-2.5 md:pr-[38px] pr-5 px-4 pb-2 sm:w-[30%] w-full">
                            <div className="flex items-center">
                                <p className="text-xs3 font-semibold text-[090406]"><ShimmerBadge/></p>
                                <p className="text-xs3 font-normal text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5"></p>
                                <button data-tooltip-target="tooltip-information" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                    <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer" />
                                </button>
                            </div>
                            <div className="pt-1">
                                <p className="text-xs3 font-normal text-[#616874]"><ShimmerBadge width={130}/></p>
                                <p className="text-xs3 font-bold text-[#555259]"><ShimmerBadge/></p>
                            </div>
                        </div>
                        <div className="bg-[#EAEAF0] rounded-md px-4 pt-4 sm:w-[70%] w-full sm:mt-0 mt-4 sm:ml-2 ml-0">
                            <div className="flex">
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]"><ShimmerBadge width={130}/></p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]"><ShimmerBadge/></p>
                                </div>
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]"><ShimmerBadge width={130}/></p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]"><ShimmerBadge/></p>
                                </div>
                            </div>
                            <div className="flex pt-4">
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]"><ShimmerBadge width={130}/></p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]"><ShimmerBadge/></p>
                                </div>
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]"><ShimmerBadge width={130}/></p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]"><ShimmerBadge/></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xl:w-[25%] w-full  xl:pt-0 pt-5 px-3 self-end">
                    <div className="sm:px-5 px-4 pt-4 sm:pb-5  border border-[#E9EDF4] rounded-[10px]">
                        <div className="flex justify-between items-center  border-b border-[#E9EDF4]">
                            <p className="text-xs3 font-semibold text-[#808285]"><ShimmerBadge/></p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#090406]"><ShimmerBadge/></p>
                        </div>
                        <div className="flex justify-between items-center py-3 border-b border-[#E9EDF4]">
                            <p className="text-xs3 font-semibold text-[#808285]"><ShimmerBadge/></p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#090406]"><ShimmerBadge/></p>
                        </div>
                        <button className="rounded-lg w-full sm:h-10 h-8 text-sm font-semibold text-[#FFFFFF] bg-[#f0f0f0] mt-6" type="button" data-bs-toggle="modal" data-bs-target="#addtocart">
                            <ShimmerBadge/>
                        </button>
                        <button className="rounded-lg w-full sm:h-10 h-8 text-sm font-semibold text-[#b4b2b7] border border-[#b4b2b7] mt-2" type="button" data-bs-toggle="modal" data-bs-target="#addtoWishlistmodal">
                            <ShimmerBadge/>
                        </button>
                    </div>
                </div>
            </div>
            <div className="border-b border-[#E9EDF4] relative mt-7">
                <div className="bg-[#FFFFFF] absolute -top-3 left-0 text-[#090406] text-base font-semibold"><ShimmerBadge/></div>
            </div>
            <div id="carouselExampleControls1" className="carousel slide relative pb-10 pt-2.5 mt-3" data-bs-ride="carousel" data-bs-interval="false">
                <div className="carousel-inner relative w-full overflow-hidden">
                    <div className="carousel-item active relative float-left w-full">
                        <div className="flex">
                            {[...Array(4)].map((item)=>(
                                <div key={item} className="min-w-[352px] border border-[#E1E1E1] rounded-lg p-2.5 ml-4">
                                    <div className="flex relative">
                                        <ShimmerThumbnail height={50}  />
                                        <div className="pl-5 w-full">
                                            <ul>
                                                <li><ShimmerCircularImage size={30} className="absolute right-2 top-0"/></li>
                                                <li className="font-semibold text-base text-[#090406]"><ShimmerBadge/></li>
                                                <p className="font-regular text-[#808285] text-xs3"><ShimmerBadge width={120}/></p>
                                                <button className="cursor-pointer bg-[#f0f0f0] rounded-lg text-[#FFFFFF] font-semibold text-xs13 w-full py-[9px] flex items-center justify-center">
                                                    <ShimmerBadge width={120}/>
                                                </button>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
